import { BehaviorSubject, Subject } from "rxjs";
import { selectIcon } from "../components/UI/selector";

const subject = new Subject();
const percentSubject = new Subject();
const toasterSubject = new Subject();
const messageSubject = new Subject();
const activitySubject = new Subject();
const headerFilterSubject = new Subject();
const gymIDSubject = new Subject();
const modalSubject = new Subject();
const stopWorkoutSubject = new Subject();
const stopActivitySubject = new Subject();
const addRoomSubject = new Subject();
const logOutSubject = new Subject();
const sideNavSubject = new Subject();
const downloadSubject = new Subject();

// =======ONDEMAND START========
const ivsSubject = new Subject();
const seekVideoSubject = new Subject();
const seekCompleteSubject = new Subject();
const bufferingSubject = new Subject();
const playerPlaySubject = new Subject();

export const ivsSubscriber = {
  sendIvsData: (data) => ivsSubject.next({ data: data }),
  getIvsData: () => ivsSubject.asObservable(),
};

export const seekVideoSubscriber = {
  send: (data) => seekVideoSubject.next({ data: data }),
  get: () => seekVideoSubject.asObservable(),
};

export const seekCompleteSubscriber = {
  send: (data) => seekCompleteSubject.next({ data: data }),
  get: () => seekCompleteSubject.asObservable(),
};

export const bufferingSubscriber = {
  send: (data) => bufferingSubject.next({ data: data }),
  get: () => bufferingSubject.asObservable(),
};

export const playerPlaySubscriber = {
  send: (data) => playerPlaySubject.next({ data: data }),
  get: () => playerPlaySubject.asObservable(),
};

// =======ONDEMAND END========

export const modalPopup = {
  cross: true,
  outside: false,
  color: "var(--color-primary)",
};

export const dropdownStatus = {
  showOptionList: false,
  id: null,
};

const roomData = {
  detail: {},
  sendData: (data) => (roomData.detail = { ...data }),
};

const sideNavSubscriber = {
  status: true,
  send: (data) => {
    sideNavSubscriber.status = data;
    sideNavSubject.next(data);
  },
  get: () => sideNavSubject.asObservable(),
};

const logOut = {
  status: false,
  setLogOut: (data) => (logOut.status = data),
};

const gymData = {
  detail: {},
  sendData: (data) => (gymData.detail = { ...data }),
};

const headerFilterSubscriber = {
  send: (data) => headerFilterSubject.next({ data: data }),
  get: () => headerFilterSubject.asObservable(),
};

const userData = {
  detail: {},
  selectedGym: {},
  sendData: (data) => (userData.detail = { ...data }),
};

const showPassword = {
  status: false,
  changeStatus: (data) => (showPassword.status = data),
  getStatus: () => showPassword.status,
};

const messageService = {
  show: true,
  count: [],
  sendMessage: async (message) => {
    if (message) {
      await messageService.count.push(message);
    } else {
      await messageService.count.pop();
    }
    subject.next({ show: messageService.count.length > 0 });
  },
  getMessage: () => subject.asObservable(),
  sendPercentMessage: (message) =>
    percentSubject.next({ percent: message.percent, text: message.text }),
  getPercentMessage: () => percentSubject.asObservable(),
};

export const activityService = {
  sendActivityMessage: (message) => activitySubject.next(message),
  getActivityMessage: () => activitySubject.asObservable(),
};

export const downloadService = {
  sendDownload: (message) => downloadSubject.next(message),
  getDownload: () => downloadSubject.asObservable(),
};

const toasterSubscriber = {
  sendToasterData: (data) => toasterSubject.next({ data: data }),
  getToasterData: () => toasterSubject.asObservable(),
};

const messageSubscriber = {
  sendMessageData: (data) => messageSubject.next({ data: data }),
  getMessageData: () => messageSubject.asObservable(),
};

const stopWorkoutService = {
  sendStopMessage: (message) => stopWorkoutSubject.next({ data: message }),
  getStopMessage: () => stopWorkoutSubject.asObservable(),
};

const stopActivityService = {
  sendStopMessage: (message) => stopActivitySubject.next({ data: message }),
  getStopMessage: () => stopActivitySubject.asObservable(),
};

const addRoomService = {
  sendStopMessage: (message) => addRoomSubject.next({ data: message }),
  getStopMessage: () => addRoomSubject.asObservable(),
};

const logOutService = {
  sendStopMessage: (message) => logOutSubject.next({ data: message }),
  getStopMessage: () => logOutSubject.asObservable(),
  sendMessage: (message) => logOutSubject.next({ data: message }),
  getMessage: () => logOutSubject.asObservable(),
};

const gymIDService = {
  gymID: {
    id: "",
    name: "",
    code: "",
    coachId: "",
  },
  sendGymID: (data) => {
    gymIDService.gymID = { ...data };
    return gymIDSubject.next({ gymID: data });
  },
  getGymID: () => gymIDSubject.asObservable(),
};

export const streamId = {
  detail: "",
  sendData: (data) => (streamId.detail = data),
};

export const modalService = {
  sendModalMessage: (message) => modalSubject.next(message),
  getModalMessage: () => modalSubject.asObservable(),
};

const pattern = {
  memberShip: "^[a-zA-Z0-9]{8}",
  // memberShip: '^[a-zA-Z]{4}[0-9]{4}',
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  // username: /^\w+[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  username: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.)\w+[a-zA-Z0-9]$/,
  streamUrl: /^(http[s]?.*?\.m3u8$)/,
};

const imageError = (event) => {
  event.target.onerror = null;
  event.target.src = selectIcon("userDummy");
};

const imageErrors = (status, event) => {
  event.target.onerror = null;
  event.target.src = selectIcon(status);
};

export const videoPreviewSubject = new BehaviorSubject();

export {
  logOut,
  messageService,
  gymIDService,
  showPassword,
  toasterSubscriber,
  stopActivityService,
  addRoomService,
  userData,
  gymData,
  roomData,
  sideNavSubscriber,
  pattern,
  imageError,
  imageErrors,
  headerFilterSubscriber,
  stopWorkoutService,
  logOutService,
  messageSubscriber,
};
